<template>
  <div class="content">
    <page-title>Dina favoriter</page-title>
    <v-loader />
    <div v-for="(user, index) in topFavoriteList" :key="index">
      <template v-if="user.data.length > 3">
        <top-list-user :user="user" />
      </template>
    </div>
    <page-title class="my-6">Andras favoriter</page-title>
  </div>
</template>

<script>
import _ from 'lodash'
import TopListUser from './TopListUser'
import VLoader from '../VLoader'
import PageTitle from '../PageTitle'

export default {
  components: {TopListUser, VLoader, PageTitle},
  data () {
    return {
    }
  },
  computed: {
    topFavoriteList: function () {
      // Get the names of all people who has rated
      let name = this.$store.getters.raterName
      let topList = []

      // Loop through the names and pick all beers that has been rated by
      // current name.
      let result = this.$store.getters.data
      let query = name.toLowerCase()
      let userData = []
      let userBeers = []

      userData = result.filter(item => {
        return item.raters.some(rater => {
          return rater.indexOf(query) === 0
        })
      })

      userData.forEach(b => {
        let rating = null
        try {
          rating = b.ratings[name].rating
        } catch (error) {
          // console.log('There seems to be a problem with the rating value for ...')
          // console.log('Namne: ', name)
          // console.log('Beer name: ', b.name)
        }
        userBeers.push({
          name: b.name,
          average: b.average,
          rating: rating
        })
      })

      userBeers = _.orderBy(userBeers, 'rating', 'desc')
      topList.push({
        name: name,
        data: userBeers
      })

      return topList
    }
  }
}
</script>

<style lang="scss">
.top-favorite__rating {
  width: 90px;
}
</style>
